import { useTranslation } from 'react-i18next';
import { SocialAccountStatus, SocialAccountType } from '@anytag/graphql';
import { useGenerateInfluencerProfileLink } from '@anytag/shared-hooks';
import {
  PostsSection,
  InfluencerAvatar,
  InfluencerPostDetailsModal,
  InfluencerWidgetInformation
} from '@anytag/shared-molecules';
import { bigIntFormatter, formatPercent } from '@anytag/shared-utils';
import { StatsSection, ProfileWidgetTemplate } from '../../shared';
import { DefaultProfileWidgetProps } from '../../schemaTypes';
import { FacebookPageInfluencerProfile } from '../schemaTypes';

type ProfileWidgetProps = DefaultProfileWidgetProps<FacebookPageInfluencerProfile>;

export const ProfileWidget = ({
  className,
  selectButtonProps,
  profile: {
    id,
    age,
    name,
    likes,
    posts,
    avatar,
    status,
    gender,
    country,
    followers,
    engagementRate,
    isBrandAccount,
    socialAccountId,
    analyticsWarning
  }
}: ProfileWidgetProps) => {
  const { t } = useTranslation();
  const { generateProfileLink } = useGenerateInfluencerProfileLink();

  const isSignedUp = status === SocialAccountStatus.SIGNED_UP;
  const stats = [
    { label: t('HeaderColumn.Followers'), value: bigIntFormatter(followers || 0) },
    { label: t('HeaderColumn.ER'), value: formatPercent(engagementRate) },
    { label: t('HeaderColumn.Avg Likes'), value: bigIntFormatter(likes || 0, 0) }
  ];
  const profileUrl = generateProfileLink(id, {
    filter: { id: String(socialAccountId), sm: SocialAccountType.FACEBOOK_PAGE }
  });

  return (
    <ProfileWidgetTemplate className={className} selectButtonProps={selectButtonProps}>
      <InfluencerAvatar
        size="80px"
        src={avatar}
        isBrandAccount={isBrandAccount}
        socialAccountType={SocialAccountType.FACEBOOK_PAGE}
      />

      <InfluencerWidgetInformation
        age={age}
        name={name}
        gender={gender}
        country={country}
        profileUrl={profileUrl}
        isSignedUp={isSignedUp}
        isWarning={!!analyticsWarning}
      />

      <StatsSection id={id} stats={stats} />

      <PostsSection posts={posts} influencerId={id} css={{ marginLeft: '16px' }} />
      <InfluencerPostDetailsModal posts={posts} />
    </ProfileWidgetTemplate>
  );
};
